import { TreeData, TreeItem } from 'tree-dnd'
import { TreeDataItem } from './types'

export function buildItem(
  id: string | number,
  data: TreeDataItem,
  children: string[] = [],
  expandedItemIds?: (string | number)[],
): TreeItem {
  return {
    id: id.toString(),
    children: children.map((i) => i.toString()),
    hasChildren: children.length > 0,
    isExpanded: expandedItemIds?.includes(id),
    data: { ...data, id: data.file_id || data.id },
  }
}

/**
 * Parse File items into TreeData format required by tree-dnd library
 * @param items File[]
 */
export function toTree(items: TreeDataItem[], expandedItemIds?: (string | number)[]): TreeData {
  const rootId = 0
  const node2item = (item: TreeDataItem) => buildItem(item.id, item, [], expandedItemIds)

  const filteredItems = items.filter((item) => item)
  const children = filteredItems.map((item) => item.id)
  const root = buildItem(rootId, {} as TreeDataItem, children)

  return {
    rootId: rootId,
    items: {
      [root.id]: root,
      ...filteredItems.reduce((acc, i) => Object.assign(acc, { [i.id]: node2item(i) }), {}),
    },
  }
}
